import type { QuerySpec } from '@helios/powersync-client-core';

/** Row shape from the app_config PowerSync table. */
export interface AppConfigRow {
  id: string;
  org_name: string | null;
  org_localname: string | null;
  logo_url: string | null;
  country: string | null;
  region: string | null;
  language: string | null;
  currency: string | null;
  org_address: string | null;
  org_phone: string | null;
  org_mobile: string | null;
  org_email: string | null;
  sms_sender_name: string | null;
  extra_json: string | null;
  updated_at: string | null;
  updated_by: string | null;
}

/** Allowed values for patient_form_layout_mode. */
export type PatientFormLayoutMode = 'wizard' | 'single_page';

/**
 * QuerySpec for the singleton app_config row.
 */
export function qAppConfig(): QuerySpec<[]> {
  return {
    key: ['app-config'] as const,
    sql: `SELECT * FROM app_config WHERE id = 'app' LIMIT 1`,
    params: [],
    watch: ['app_config'],
  };
}

/**
 * Extract patient_form_layout_mode from an app_config row.
 * Returns 'wizard' if missing, NULL, or invalid.
 */
export function getPatientFormLayoutMode(row: AppConfigRow | undefined): PatientFormLayoutMode {
  if (!row?.extra_json) return 'wizard';
  try {
    const parsed = JSON.parse(row.extra_json);
    if (parsed?.patient_form_layout_mode === 'single_page') return 'single_page';
  } catch {
    // invalid JSON, fall through
  }
  return 'wizard';
}
